/* eslint-disable max-len */
import { ActualVersion as SvgFigureProps } from '~/utils/editor/versioning/svg-figure'

export interface Figure {
  defaultParams?: SvgFigureProps
  canRoundBorder: boolean
  svg: string
  roundBordersFunction?: (size: number, borderRadius: number) => string
}

export const figures: Figure[] = [
  {
    canRoundBorder: true,
    svg: '<svg width="59" height="59" viewBox="0 0 59 59" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="59" height="59" fill="#696969"/></svg>',
  },
  {
    defaultParams: {
      borderRadius: 40,
    },
    canRoundBorder: true,
    svg: '<svg width="59" height="59" viewBox="0 0 59 59" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="59" height="59" rx="12" fill="#696969"/></svg>',
  },
  {
    canRoundBorder: false,
    svg: '<svg width="59" height="59" viewBox="0 0 59 59" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M 29.5 0 A 29.5 29.5 0 0 1 29.5 59 A 29.5 29.5 0 0 1 29.5 0 Z" fill="#696969"/></svg>',
  },
  {
    canRoundBorder: true,
    svg: '<svg width="59" height="59" viewBox="0 0 59 59" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M 0 59 A 0 0 0 0 1 0 59 L 29.5 0 A 0 0 0 0 1 29.5 0 L 59 59 A 0 0 0 0 1 59 59 Z" fill="#696969"/></svg>',
    roundBordersFunction: (size: number, borderRadius: number): string => {
      const radius = (borderRadius > size / 2) ? size / 2 : borderRadius
      const r075 = radius * 0.75
      const r03 = radius * 0.3
      const sizeDiffRadius = size - radius
      return `
        M ${radius} ${size}
        A ${r075} ${r075} 0 0 1 ${r03} ${sizeDiffRadius}
        L ${sizeDiffRadius / 2} ${r075}
        A ${r075} ${radius * 1.25} 0 0 1 ${(size + radius) / 2} ${r075}
        L ${size - r03} ${sizeDiffRadius}
        A ${r075} ${r075} 0 0 1 ${sizeDiffRadius} ${size}
        Z
      `
    },
  },
  {
    canRoundBorder: true,
    svg: '<svg width="59" height="59" viewBox="0 0 59 59" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M 0 0 A 0 0 0 0 0 0 0 L 29.5 59 A 0 0 0 0 0 29.5 59 L 59 0 A 0 0 0 0 0 59 0 Z" fill="#696969"/></svg>',
    roundBordersFunction: (size: number, borderRadius: number): string => {
      const radius = (borderRadius > size / 2) ? size / 2 : borderRadius
      const r075 = radius * 0.75
      const r03 = radius * 0.3
      const sizeDiffRadius = size - radius
      return `
        M ${radius} 0
        A ${r075} ${r075} 0 0 0 ${r03} ${radius}
        L ${sizeDiffRadius / 2} ${size - r075}
        A ${r075} ${radius * 1.25} 0 0 0 ${(size + radius) / 2} ${size - r075}
        L ${size - r03} ${radius}
        A ${r075} ${r075} 0 0 0 ${sizeDiffRadius} 0
        Z
      `
    },
  },
  {
    canRoundBorder: true,
    svg: '<svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M 0 30 A 0 0 0 0 1 0 30 L 30 0 A 0 0 0 1 0 30 0 L 60 30 A 0 0 0 0 1 60 30 L 30 60 A 0 0 0 0 1 30 60 Z" fill="#696969"/></svg>',
    roundBordersFunction: (size: number, borderRadius: number): string => {
      const halfSize = size / 2
      const radius = (borderRadius > halfSize) ? Math.sqrt(halfSize * halfSize / 2) : Math.sqrt(borderRadius * borderRadius / 2)
      const katet = Math.sqrt(radius * radius / 2)
      const halfSizeDiffKatet = halfSize - katet
      const halfSizeWithKatet = halfSize + katet
      return `
        M ${katet} ${halfSizeWithKatet}
        A ${radius} ${radius} 0 0 1 ${katet} ${halfSizeDiffKatet}
        L ${halfSizeDiffKatet} ${katet}
        A ${radius} ${radius} 0 0 1 ${halfSizeWithKatet} ${katet}
        L ${size - katet} ${halfSizeDiffKatet}
        A ${radius} ${radius} 0 0 1 ${size - katet} ${halfSizeWithKatet}
        L ${halfSizeWithKatet} ${size - katet}
        A ${radius} ${radius} 0 0 1 ${halfSizeDiffKatet} ${size - katet}
        Z
      `
    },
  },
  {
    defaultParams: {
      width: 200,
      height: 189,
    },
    canRoundBorder: false,
    svg: '<svg width="57" height="54" viewBox="0 0 57 54" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M28.5 0L56.5562 20.384L45.8397 53.366H11.1603L0.443832 20.384L28.5 0Z" fill="#696969"/></svg>',
  },
  {
    defaultParams: {
      width: 200,
      height: 222,
    },
    canRoundBorder: false,
    svg: '<svg width="53" height="59" viewBox="0 0 53 59" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M26.5 0L52.0477 14.75V44.25L26.5 59L0.952251 44.25V14.75L26.5 0Z" fill="#696969"/></svg>',
  },
  {
    defaultParams: {
      width: 200,
      height: 179,
    },
    canRoundBorder: false,
    svg: '<svg width="59" height="53" viewBox="0 0 59 53" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M59 26.5L44.25 52.0477L14.75 52.0477L-1.28949e-06 26.5L14.75 0.95225L44.25 0.952251L59 26.5Z" fill="#696969"/></svg>',
  },
  {
    canRoundBorder: false,
    svg: '<svg width="55" height="55" viewBox="0 0 55 55" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15.9653 0L38.5436 9.05613e-07L54.5089 15.9653L54.5089 38.5436L38.5436 54.5089L15.9653 54.5089L0 38.5436L9.05613e-07 15.9653L15.9653 0Z" fill="#696969"/></svg>',
  },
  {
    canRoundBorder: false,
    svg: '<svg width="59" height="59" viewBox="0 0 59 59" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M29.5 0L37.4677 21.5323L59 29.5L37.4677 37.4677L29.5 59L21.5323 37.4677L0 29.5L21.5323 21.5323L29.5 0Z" fill="#696969"/></svg>',
  },
  {
    defaultParams: {
      width: 200,
      height: 189,
    },
    canRoundBorder: false,
    svg: '<svg width="57" height="54" viewBox="0 0 57 54" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M28.5 0L35.1232 20.384H56.5562L39.2165 32.982L45.8397 53.366L28.5 40.768L11.1603 53.366L17.7835 32.982L0.443832 20.384H21.8768L28.5 0Z" fill="#696969"/></svg>',
  },
  {
    defaultParams: {
      width: 200,
      height: 222,
    },
    canRoundBorder: false,
    svg: '<svg width="53" height="59" viewBox="0 0 53 59" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M26.5 0L36.5595 12.0764L52.0477 14.75L46.619 29.5L52.0477 44.25L36.5595 46.9236L26.5 59L16.4405 46.9236L0.952251 44.25L6.381 29.5L0.952251 14.75L16.4405 12.0764L26.5 0Z" fill="#696969"/></svg>',
  },
  {
    canRoundBorder: false,
    svg: '<svg width="59" height="59" viewBox="0 0 59 59" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M29.5 0L37.1992 10.9125L50.3596 8.64035L48.0875 21.8008L59 29.5L48.0875 37.1992L50.3596 50.3596L37.1992 48.0875L29.5 59L21.8008 48.0875L8.64035 50.3596L10.9125 37.1992L0 29.5L10.9125 21.8008L8.64035 8.64035L21.8008 10.9125L29.5 0Z" fill="#696969"/></svg>',
  },
  {
    defaultParams: {
      width: 200,
      height: 207,
    },
    canRoundBorder: false,
    svg: '<svg width="57" height="59" viewBox="0 0 57 59" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M28.5 0L34.7171 10.3657L45.8397 5.634L44.7766 17.6743L56.5562 20.384L48.619 29.5L56.5562 38.616L44.7766 41.3257L45.8397 53.366L34.7171 48.6343L28.5 59L22.2829 48.6343L11.1603 53.366L12.2234 41.3257L0.443832 38.616L8.381 29.5L0.443832 20.384L12.2234 17.6743L11.1603 5.634L22.2829 10.3657L28.5 0Z" fill="#696969"/></svg>',
  },
  {
    canRoundBorder: false,
    svg: '<svg width="59" height="59" viewBox="0 0 59 59" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M29.5 0L34.8959 5.85897L42.2996 2.92142L44.619 10.5414L52.564 11.107L51.3476 18.9788L58.2604 22.9356L53.749 29.5L58.2604 36.0644L51.3476 40.0212L52.564 47.893L44.619 48.4586L42.2996 56.0786L34.8959 53.141L29.5 59L24.1041 53.141L16.7004 56.0786L14.381 48.4586L6.43597 47.893L7.6524 40.0212L0.739626 36.0644L5.251 29.5L0.739626 22.9356L7.6524 18.9788L6.43597 11.107L14.381 10.5414L16.7004 2.92142L24.1041 5.85897L29.5 0Z" fill="#696969"/></svg>',
  },
  {
    defaultParams: {
      width: 200,
      height: 206,
    },
    canRoundBorder: false,
    svg: '<svg width="59" height="61" viewBox="0 0 59 61" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M26.3486 1.97811C27.6398 -0.659373 31.3602 -0.65937 32.6514 1.97812L32.988 2.66588C33.9758 4.68356 36.5461 5.27672 38.3019 3.89216L38.9004 3.42021C41.1955 1.61033 44.5475 3.24242 44.5789 6.18513L44.5871 6.95249C44.6112 9.20366 46.6725 10.8657 48.8485 10.3885L49.5903 10.2258C52.4348 9.60198 54.7544 12.5429 53.52 15.208L53.1981 15.903C52.2537 17.9418 53.3976 20.3434 55.5629 20.8681L56.301 21.0469C59.1316 21.7327 59.9594 25.4 57.7035 27.2596L57.1153 27.7446C55.3895 29.1672 55.3895 31.8328 57.1153 33.2554L57.7035 33.7404C59.9594 35.6 59.1316 39.2673 56.301 39.9531L55.5629 40.1319C53.3976 40.6566 52.2537 43.0582 53.1981 45.097L53.52 45.792C54.7544 48.4571 52.4348 51.398 49.5903 50.7742L48.8485 50.6115C46.6725 50.1343 44.6112 51.7963 44.5871 54.0475L44.5789 54.8149C44.5475 57.7576 41.1955 59.3897 38.9004 57.5798L38.3019 57.1078C36.5461 55.7233 33.9758 56.3164 32.988 58.3341L32.6514 59.0219C31.3602 61.6594 27.6398 61.6594 26.3486 59.0219L26.012 58.3341C25.0242 56.3164 22.4539 55.7233 20.6981 57.1078L20.0996 57.5798C17.8045 59.3897 14.4525 57.7576 14.4211 54.8149L14.4129 54.0475C14.3888 51.7963 12.3275 50.1343 10.1515 50.6115L9.40972 50.7742C6.5652 51.398 4.24557 48.4571 5.48004 45.792L5.80195 45.097C6.74632 43.0582 5.6024 40.6566 3.43706 40.1319L2.69895 39.9531C-0.131557 39.2673 -0.959423 35.6 1.29647 33.7404L1.88473 33.2554C3.61049 31.8328 3.61049 29.1672 1.88473 27.7446L1.29647 27.2596C-0.959424 25.4 -0.131555 21.7327 2.69896 21.0469L3.43706 20.8681C5.6024 20.3434 6.74631 17.9418 5.80195 15.903L5.48004 15.208C4.24557 12.5429 6.56521 9.60198 9.40972 10.2258L10.1515 10.3885C12.3275 10.8657 14.3888 9.20366 14.4129 6.95249L14.4211 6.18513C14.4525 3.24242 17.8045 1.61033 20.0996 3.42021L20.6981 3.89217C22.4539 5.27672 25.0242 4.68356 26.012 2.66588L26.3486 1.97811Z" fill="#696969"/></svg>',
  },
  {
    defaultParams: {
      width: 200,
      height: 206,
    },
    canRoundBorder: false,
    svg: '<svg width="59" height="61" viewBox="0 0 59 61" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M26.4022 0.791075C28.3311 -0.263691 30.6689 -0.263692 32.5978 0.791074L37.1331 3.27118C37.844 3.65993 38.6226 3.91135 39.4276 4.01216L44.5635 4.65526C46.7478 4.92876 48.6392 6.29454 49.5759 8.27469L51.7783 12.9307C52.1236 13.6605 52.6047 14.3187 53.1964 14.8706L56.9711 18.3913C58.5765 19.8886 59.2989 22.0984 58.8856 24.2476L57.9139 29.3011C57.7616 30.0932 57.7616 30.9068 57.9139 31.6989L58.8856 36.7524C59.2989 38.9016 58.5765 41.1114 56.9711 42.6087L53.1964 46.1294C52.6047 46.6813 52.1236 47.3395 51.7783 48.0693L49.5759 52.7253C48.6392 54.7055 46.7478 56.0712 44.5635 56.3447L39.4276 56.9878C38.6226 57.0886 37.844 57.3401 37.1331 57.7288L32.5978 60.2089C30.6689 61.2637 28.3311 61.2637 26.4022 60.2089L21.8669 57.7288C21.156 57.3401 20.3774 57.0886 19.5723 56.9878L14.4365 56.3447C12.2522 56.0712 10.3608 54.7055 9.42414 52.7253L7.22168 48.0693C6.87644 47.3395 6.39527 46.6813 5.80359 46.1294L2.02889 42.6087C0.423536 41.1114 -0.298904 38.9016 0.114352 36.7524L1.08605 31.6989C1.23836 30.9068 1.23836 30.0932 1.08605 29.3011L0.114352 24.2476C-0.298903 22.0984 0.423534 19.8886 2.02888 18.3913L5.80359 14.8706C6.39527 14.3187 6.87644 13.6605 7.22168 12.9307L9.42414 8.27469C10.3608 6.29454 12.2522 4.92877 14.4364 4.65526L19.5724 4.01216C20.3774 3.91135 21.156 3.65993 21.8669 3.27118L26.4022 0.791075Z" fill="#696969"/></svg>',
  },
  {
    defaultParams: {
      width: 200,
      height: 157,
    },
    canRoundBorder: false,
    svg: '<svg width="52" height="41" viewBox="0 0 52 41" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M23 41L52 20.5L23 0V9H0V32H23V41Z" fill="#696969"/></svg>',
  },
  {
    defaultParams: {
      width: 200,
      height: 253,
    },
    canRoundBorder: false,
    svg: '<svg width="41" height="52" viewBox="0 0 41 52" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M-1.00536e-06 23L20.5 52L41 23L32 23L32 -3.93402e-07L9 -1.39876e-06L9 23L-1.00536e-06 23Z" fill="#696969"/></svg>',
  },
  {
    defaultParams: {
      width: 200,
      height: 157,
    },
    canRoundBorder: false,
    svg: '<svg width="52" height="41" viewBox="0 0 52 41" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M29 -2.01072e-06L1.79217e-06 20.5L29 41L29 32L52 32L52 9L29 9L29 -2.01072e-06Z" fill="#696969"/></svg>',
  },
  {
    defaultParams: {
      width: 200,
      height: 253,
    },
    canRoundBorder: false,
    svg: '<svg width="41" height="52" viewBox="0 0 41 52" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M41 29L20.5 -8.96084e-07L-1.00536e-06 29L9 29L9 52L32 52L32 29L41 29Z" fill="#696969"/></svg>',
  },
  {
    defaultParams: {
      width: 200,
      height: 98,
    },
    canRoundBorder: false,
    svg: '<svg width="67" height="33" viewBox="0 0 67 33" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0 16.5L23.9877 33V25.7561H43.0123V33L67 16.5L43.0123 0V7.2439H23.9877V0L0 16.5Z" fill="#696969"/></svg>',
  },
  {
    defaultParams: {
      width: 200,
      height: 110,
    },
    canRoundBorder: false,
    svg: '<svg width="60" height="33" viewBox="0 0 60 33" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0 0H40.2273L60 16.5L40.2273 33H0V0Z" fill="#696969"/></svg>',
  },
  {
    defaultParams: {
      width: 200,
      height: 112,
    },
    canRoundBorder: false,
    svg: '<svg width="48" height="27" viewBox="0 0 48 27" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0 0H32.1818L48 13.5L32.1818 27H0L16 13.5L0 0Z" fill="#696969"/></svg>',
  },
  {
    defaultParams: {
      width: 200,
      height: 84,
    },
    canRoundBorder: false,
    svg: '<svg width="64" height="27" viewBox="0 0 64 27" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M31.8182 0H0L16 13.5L0 27H31.8182H32.1818H64L48 13.5L64 0H32.1818H31.8182Z" fill="#696969"/></svg>',
  },
  {
    defaultParams: {
      width: 200,
      height: 84,
    },
    canRoundBorder: false,
    svg: '<svg width="64" height="27" viewBox="0 0 64 27" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15.8182 0H48.1818L64 13.5L48.1818 27H15.8182L0 13.5L15.8182 0Z" fill="#696969"/></svg>',
  },
  {
    defaultParams: {
      borderRadius: 13.5,
      width: 200,
      height: 91,
    },
    canRoundBorder: false,
    svg: '<svg width="59" height="27" viewBox="0 0 59 27" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M 13.5 0 L 45.5 0 A 13.5 13.5 0 0 1 45.5 27 L 13.5 27 A 13.5 13.5 0 0 1 13.5 0 Z" fill="#696969"/></svg>',
  },
  {
    defaultParams: {
      width: 200,
      height: 169,
    },
    canRoundBorder: false,
    svg: '<svg width="59" height="50" viewBox="0 0 59 50" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0 0H59V39H23L9 49.5L8.5 39H0V0Z" fill="#696969"/></svg>',
  },
  {
    defaultParams: {
      width: 200,
      height: 159,
    },
    canRoundBorder: false,
    svg: '<svg width="59" height="47" viewBox="0 0 59 47" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0 3C0 1.34315 1.34315 0 3 0H56C57.6569 0 59 1.34315 59 3V36C59 37.6569 57.6569 39 56 39H24C23.3509 39 22.7193 39.2105 22.2 39.6L13.5274 46.1044C11.6019 47.5485 8.8453 46.2513 8.73082 43.8471L8.63606 41.8573C8.55989 40.2577 7.24084 39 5.63946 39H3C1.34315 39 0 37.6569 0 36V3Z" fill="#696969"/></svg>',
  },
  {
    defaultParams: {
      width: 200,
      height: 178,
    },
    canRoundBorder: false,
    svg: '<svg width="55" height="49" viewBox="0 0 55 49" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M27.316 48.3942L4.36451 25.4428C0.354549 21.4328 -1.03147 15.4942 0.789122 10.1234C4.16289 0.170822 16.5025 -3.25564 24.5248 3.5325L27.316 5.89423L30.1071 3.53251C38.1294 -3.25563 50.4691 0.170821 53.8428 10.1234C55.6634 15.4942 54.2774 21.4328 50.2674 25.4427L27.316 48.3942Z" fill="#696969"/></svg>',
  },
  {
    defaultParams: {
      width: 200,
      height: 196,
    },
    canRoundBorder: false,
    svg: '<svg width="52" height="51" viewBox="0 0 52 51" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M36 0H16V15.5H0.5V35.5H16V51H36V35.5H51.5V15.5H36V0Z" fill="#696969"/></svg>',
  },
  {
    defaultParams: {
      width: 200,
      height: 131,
    },
    canRoundBorder: false,
    svg: '<svg width="67" height="44" viewBox="0 0 67 44" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M44.6361 6.52065C43.0117 2.69106 39.1731 0 34.6964 0C30.6155 0 27.0647 2.23634 25.2383 5.53285C23.5859 4.51613 21.6335 3.92857 19.5417 3.92857C13.6666 3.92857 8.89038 8.56354 8.7759 14.324C3.78063 15.2443 0 19.5622 0 24.75C0 30.6082 4.82094 35.3571 10.7679 35.3571C12.6184 35.3571 14.3599 34.8973 15.881 34.0873C17.4421 38.0488 21.3495 40.8571 25.9226 40.8571C28.1592 40.8571 30.2365 40.1855 31.958 39.0357C33.8638 42.0182 37.2356 44 41.0774 44C46.1564 44 50.4142 40.536 51.5487 35.8754C52.9648 36.5502 54.5536 36.9286 56.2321 36.9286C62.1791 36.9286 67 32.1796 67 26.3214C67 22.264 64.6874 18.7387 61.2898 16.9548C61.3733 16.4224 61.4167 15.8769 61.4167 15.3214C61.4167 9.46324 56.5957 4.71429 50.6488 4.71429C48.4221 4.71429 46.3532 5.38011 44.6361 6.52065Z" fill="#696969"/></svg>',
  },
  {
    defaultParams: {
      width: 200,
      height: 243,
    },
    canRoundBorder: false,
    svg: '<svg width="51" height="62" viewBox="0 0 51 62" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0 0H51V46L25.5 62L0 46V0Z" fill="#696969"/></svg>',
  },
  {
    defaultParams: {
      width: 200,
      height: 235,
    },
    canRoundBorder: false,
    svg: '<svg width="51" height="60" viewBox="0 0 51 60" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0 0H51V60L25.5 45.6522L0 60V0Z" fill="#696969"/></svg>',
  },
  {
    canRoundBorder: false,
    svg: '<svg width="59" height="59" viewBox="0 0 59 59" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0 7C3.86597 7 7 3.86597 7 0H52C52 3.86597 55.134 7 59 7V52C55.134 52 52 55.134 52 59H7C7 55.134 3.86597 52 0 52V7Z" fill="#696969"/></svg>',
  },
  {
    canRoundBorder: false,
    svg: '<svg width="59" height="59" viewBox="0 0 59 59" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10 0H49L59 10V49L49 59H10L0 49V10L10 0Z" fill="#696969"/></svg>',
  },
  {
    defaultParams: {
      width: 200,
      height: 177,
    },
    canRoundBorder: false,
    svg: '<svg width="62" height="55" viewBox="0 0 62 55" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0 10L31 0L62 10V45L31 55L0 45V10Z" fill="#696969"/></svg>',
  },
  {
    defaultParams: {
      width: 200,
      height: 218,
    },
    canRoundBorder: false,
    svg: '<svg width="54" height="49" viewBox="0 0 54 49" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10 0H54L44 49H0L10 0Z" fill="#696969"/></svg>',
  },
  {
    defaultParams: {
      width: 200,
      height: 218,
    },
    canRoundBorder: false,
    svg: '<svg width="54" height="49" viewBox="0 0 54 49" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M44 0H0L10 49H54L44 0Z" fill="#696969"/></svg>',
  },
  {
    defaultParams: {
      width: 200,
      height: 153,
    },
    canRoundBorder: false,
    svg: '<svg width="64" height="49" viewBox="0 0 64 49" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M54 0H10L0 49H64L54 0Z" fill="#696969"/></svg>',
  },
  {
    defaultParams: {
      width: 200,
      height: 153,
    },
    canRoundBorder: false,
    svg: '<svg width="64" height="49" viewBox="0 0 64 49" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10 49L54 49L64 1.11901e-05L8.56743e-06 0L10 49Z" fill="#696969"/></svg>',
  },
  {
    defaultParams: {
      width: 200,
      height: 280,
    },
    canRoundBorder: false,
    svg: '<svg width="40" height="56" viewBox="0 0 40 56" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0 20C0 8.9543 8.95431 0 20 0C31.0457 0 40 8.9543 40 20V56H0V20Z" fill="#696969"/></svg>',
  },
  {
    defaultParams: {
      width: 200,
      height: 280,
    },
    canRoundBorder: false,
    svg: '<svg width="40" height="56" viewBox="0 0 40 56" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0 36C0 47.0457 8.95431 56 20 56C31.0457 56 40 47.0457 40 36V0H0V36Z" fill="#696969"/></svg>',
  },
]
